var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "bottom", width: "150", trigger: "click" } },
    [
      _c(
        "v-btn",
        {
          attrs: { slot: "reference", icon: "", large: "" },
          slot: "reference"
        },
        [_c("img", { attrs: { src: _vm.selectImg } })]
      ),
      _vm._v(" "),
      _c(
        "v-list",
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "v-list-tile",
            {
              key: item.label,
              on: {
                click: function($event) {
                  return _vm.handleSetLanguage(item)
                }
              }
            },
            [
              _c("v-list-tile", [_c("img", { attrs: { src: item.img } })]),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [_c("v-list-tile-title", [_vm._v(_vm._s(item.label))])],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }